export const toYesNo = (value: boolean | null | undefined, t: (key: string) => string): string =>
  value ? t("common.yes") : t("common.no");
